import React from 'react';
import NetValueContent from './NetValueContent';
import WidgetAlert, { WidgetErrorType } from 'components/widgetParts/WidgetAlert';
import { useTranslation } from 'react-i18next';
import withQueryWidget, { WithQueryWidgetProps } from 'components/widgetParts/queryWidgetComposition/withQueryWidget';
import { getSingleOriginalRequestByName, getSingleWidgetResponseByName } from 'system/widget/Widget';

function NetValueWidgetContent(props: WithQueryWidgetProps): JSX.Element {
  const { i18n } = useTranslation();

  const activeRequest = getSingleOriginalRequestByName(props.activeWidgetRequests, 'net-value');
  const aggs = activeRequest?.requestInit?.body?.aggs?.net_value;
  const topOptionKey = aggs?.filter?.[0];
  const bottomOptionKey = aggs?.filter?.[1];

  const apiResponseInfo = getSingleWidgetResponseByName(props.apiResponses, 'net-value');
  const response = apiResponseInfo?.responseBody;

  const fieldResponse = response?.["net_value"];
  const fieldLabel = fieldResponse?._field_label;

  const topBucket = fieldResponse?._buckets?.find((bucket: any) => bucket._key === topOptionKey);
  const bottomBucket = fieldResponse?._buckets?.find((bucket: any) => bucket._key === bottomOptionKey);
  const topValue = topBucket?._count || 0;
  const bottomValue = bottomBucket?._count || 0;
  let topLabel = topBucket?._label || props.widget?.data?.settings?.topValueLabel;
  let bottomLabel = bottomBucket?._label || props.widget?.data?.settings?.bottomValueLabel;

  if (!topLabel && topOptionKey === "p" && fieldResponse?._field_id === "sentiment") {
    topLabel = i18n.t("positive");
  }
  if (!bottomLabel && bottomOptionKey === "n" && fieldResponse?._field_id === "sentiment") {
    bottomLabel = i18n.t("negative");
  }
  topLabel = topLabel || topOptionKey;
  bottomLabel = bottomLabel || bottomOptionKey;

  return (
    <>
      {((topBucket || bottomBucket) && (topValue !== 0 || bottomValue !== 0)) &&
        <NetValueContent
          fieldLabel={fieldLabel}
          topValue={topValue}
          bottomValue={bottomValue}
          topLabel={topLabel}
          bottomLabel={bottomLabel}
          settingsState={props.widget?.data?.settings}
          widgetQueryTitle={apiResponseInfo?.queryDisplayTitle} />
      }
      {((!topBucket && !bottomBucket) || (topValue === 0 && bottomValue === 0)) &&
        <WidgetAlert type={WidgetErrorType.NO_DATA} />
      }
    </>
  );
}

export default withQueryWidget(NetValueWidgetContent, {
  hasSettingsDialog: true,
  hasQueryDialog: true
});
